<template>
    <div v-if="lancamento && lancamento.item_pagamento_atendimento && lancamento.item_pagamento_atendimento.pagamento_atendimento">
        <template v-if="lancamento.item_pagamento_atendimento.nota_fiscal_links && Array.isArray(lancamento.item_pagamento_atendimento.nota_fiscal_links) && lancamento.item_pagamento_atendimento.nota_fiscal_links.length > 0">
            <template v-for="(nfl, nf_idx) in lancamento.item_pagamento_atendimento.nota_fiscal_links">
                <br v-if="nf_idx > 0" :key="'A' + nf_idx"/>
                {{ titulo }}
                <span v-if="nfl.nota_fiscal_servico" :class="getNFStatusClass(nfl.nota_fiscal_servico.ch_status)" :key="nf_idx">
                    <span v-if="exibe_numero && nfl.nota_fiscal_servico.numero_completo">
                        {{ nfl.nota_fiscal_servico.numero_completo + ' - ' + getNFStatusDesc(nfl.nota_fiscal_servico.ch_status) }}
                    </span>
                    <span v-else>
                        {{ nfl.nota_fiscal_servico.st_numero + ' - ' + getNFStatusDesc(nfl.nota_fiscal_servico.ch_status) }}
                    </span>
                </span>
            </template>
        </template>
        <template v-else-if="lancamento.item_pagamento_atendimento.pagamento_atendimento.st_numero_nf">
            {{ titulo }}
            {{ lancamento.item_pagamento_atendimento.pagamento_atendimento.st_numero_nf }}
            <span v-if="lancamento.item_pagamento_atendimento.pagamento_atendimento.st_chave_acesso">
                <br />
                <small class="text-muted">
                    {{ lancamento.item_pagamento_atendimento.pagamento_atendimento.st_chave_acesso }}
                </small>
            </span>
        </template>
    </div>
</template>

<script>

export default {
    props: ['lancamento', 'titulo', 'exibe_numero'], 

    methods: { 
        getNFStatusClass: function(status) {
            switch (status) {
                case "1":
                    return "text-info";
                case "2":
                    return "text-primary";
                case "3":
                    return "text-warning";
                case "4":
                    return "text-success";
                case "5":
                    return "text-danger";

                default:
                    return "text-info";
            }
        },
        getNFStatusDesc: function(status) {
            switch (status) {
                case "1":
                    return "Gerada";
                case "2":
                    return "Não Processada";
                case "3":
                    return "Processado com Erro";
                case "4":
                    return "Emitida";
                case "5":
                    return "Cancelada";

                default:
                    return "";
            }
        },
    }
}
</script>
